import { Utilities } from "./utilities";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import * as firebase from "firebase";
import { Observable } from "rxjs/Observable";
import { IStaff } from "../shared/models/staff.model";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class StaffData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private tracking: TrackingProvider,
    private historyData: HistoryData,
    private utilities: Utilities,
  ) { }

  public createOrUpdateStaff(clientId: string, staff: IStaff, eventId: string) {
    if (staff.id === "") {
      this.action = "create";
      staff.id = this.afDb.createPushId();
      staff.created_at = new Date().getTime();
    } else {
      this.action = "update";
      staff.update_at = new Date().getTime();
    }

    let reference = `Clients/${clientId}/Interactivity/Staff/${staff.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Staff/${staff.id}`;
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(reference)
        .update(staff)
        .then(() => {
          this.tracking.trackEntityPromise(_TRACKING_ENTITIES.staff, staff.id, clientId, eventId, staff, "Creacion/actualizacion staff");
          return true;
        })
        // .then(() => {
        //   return this.historyData.set(
        //     `Staff content`,
        //     "staff",
        //     this.action,
        //     staff,
        //   );
        // })
        .then(() => resolve(staff))
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getStaffsByClientId(clientId: string, eventId: string): any {
    let reference = `Clients/${clientId}/Interactivity/Staff`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Staff`;
    }
    return this.afDb.list<IStaff>(reference).valueChanges();
  }

  public getStaffsConfigByClientId(client: string): any {
    return this.afDb.list<IStaff>(`ClientConfig/${client}/Staff`).valueChanges();
  }

  public getStaffByStaffId(clientId: string, staffId: string, eventId: string): Observable<IStaff> {
    let reference = `Clients/${clientId}/Interactivity/Staff/${staffId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Staff/${staffId}`;
    }
    return this.afDb
      .object<IStaff>(reference)
      .valueChanges();
  }

  public getEventStaff(client: string, id: string): any {
    return this.afDb.object(`Clients/${client}/Staff/${id}`).valueChanges();
  }

  public getStaffCategories(client: string): Observable<any[]> {
    return this.afDb.list(`Clients/${client}/StaffCategories`).valueChanges();
  }

  public createOrUpdateStaffCategory(client: string, category: any) {
    if (category.id === "") {
      this.action = "create";
      category.id = this.afDb.createPushId();
      category.created_at = new Date().getTime();
    } else {
      this.action = "update";
      category.update_at = new Date().getTime();
    }
    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${client}/StaffCategories/${category.id}`)
        .update(category)
        .then(() => {
          return this.historyData.set(
            `Staff category content`,
            "staff",
            this.action,
            category,
          );
        })
        .then(() => {
          resolve(category);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getEventStaffPromise(client: string, id: string): any {
    return firebase.database().ref(`Clients/${client}/Staff/${id}`).once("value");
  }

  public getEventStaffByIdPromise(client: string, id: string): any {
    return firebase.database().ref(`Clients/${client}/Staff/${id}`)
      .once("value")
      .then((snap) => snap.val());
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/staff.ts